<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="top-block">
        <img class="crescent-img slicing" src="@/assets/img/crescent.png" />
        <img class="crown-img slicing" src="@/assets/img/crown.png" />
        <img class="title-img slicing" src="@/assets/img/rank_title.png" />
        <div class="finish-time slicing">完成时间: {{ startDate }} 至 {{ endDate }}</div>
      </div>
      <van-sticky>
        <TabBarWrp class="tab-bar">
          <van-tabs
            :color="primaryColor"
            line-width="28px"
            :title-inactive-color="blackColor6"
            :title-active-color="primaryColor"
            v-model:active="postListParams.rankType"
            @click-tab="onClickTab"
          >
            <van-tab v-for="item in tabColum" :name="item.key" :key="item.key" :title="item.title" />
          </van-tabs>
        </TabBarWrp>
      </van-sticky>
      <div class="list-wrp">
        <van-row class="list-title">
          <van-col
            :style="{ textAlign: item.align }"
            v-for="(item, index) in listColum"
            :span="item.span"
            :key="index"
            >{{ item.title }}</van-col
          >
        </van-row>
        <div class="van-hairline--bottom"></div>
        <div class="list-box">
          <van-list
            :immediate-check="false"
            v-model:loading="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="getList"
          >
            <RankListItem
              v-for="item in list"
              :rankType="postListParams.rankType"
              v-bind="item"
              :agentInfo="item"
              :key="item.puid"
              :spans="listColum.map(d => d.span)"
              class="rank-list-item"
            />
          </van-list>
          <van-empty
            v-if="list.length == 0 && !loading"
            image-size="240"
            image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
            description="暂无数据"
          />
        </div>
        <div class="fixed-bottom-rank" v-if="postListParams.rankType === RankTypeEnum.ACTIVE_VALUE">
          <RankListItem
            showPlace="bottom"
            :rankType="postListParams.rankType"
            v-bind="userSelfRankInfo"
            :agentInfo="userSelfRankInfo"
            :spans="Number(userSelfRankInfo.diffValue) ? [4, 10, 10] : [6, 12, 6]"
          />
        </div>
        <back-top />
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, reactive } from 'vue'
import { useCssVar } from '@vueuse/core'
import { useRouter } from 'vue-router'
import { getUserBriskPeriodRankApi } from '@/api/brisk'
import { TabBarWrp, BackTop } from '@/components'
import RankListItem from './component/RankListItem'
import { tabColum, listTitleColum, RankTypeEnum } from './brisk.data'
// import { getLocal } from '@/common/js/utils'
import { transPxToRem } from '@/utils'
// import { useUserStore } from '@/store/user'

const router = useRouter()
const { currentRoute } = router
const query = currentRoute.value.query
const periodId = query?.periodId
const startDate = query?.startDate
const endDate = query?.endDate
const topBlockHeight = transPxToRem(214)
const defaultRankType = Number(query.rankType) || RankTypeEnum.ACTIVE_VALUE

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const postListParams = reactive({
  rankType: defaultRankType,
  period_id: periodId
})

const userSelfRankInfo = ref({})
const refreshing = ref(false)
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const isFistLoadList = ref(true)

const listColum = computed(() =>
  listTitleColum.filter(d => ['rank', 'user', 'brisk', postListParams.rankType].includes(d.key))
)
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  pageParams.page = 1
  list.value = []
  finished.value = false
}

const search = () => {
  reset()
  getList()
}

const onLoad = async () => {
  search()
}

const onClickTab = () => {
  search()
}

const getList = async () => {
  try {
    loading.value = true
    const { list: resList, total, userRankInfo } = await getUserBriskPeriodRankApi({ ...postListParams, ...pageParams })
    list.value.push(...resList)
    pageParams.page++
    finished.value = list.value.length === Number(total)
    userSelfRankInfo.value = userRankInfo
  } catch (e) {
    finished.value = true
    console.log(e)
  } finally {
    isFistLoadList.value = false
    loading.value = false
  }
}

const onRefresh = async () => {
  refreshing.value = true
  try {
    await onLoad()
    search()
  } finally {
    refreshing.value = false
  }
}

// const userStore = useUserStore()
const primaryColor = useCssVar('--van-primary-color', document.documentElement)
const blackColor6 = useCssVar('--van-black-6', document.documentElement)
// const theme = computed(() => userStore.getTheme)

onMounted(() => {
  onLoad()
  // primaryColor.value = theme.value.PrimaryButtonColor
})
</script>
<style lang="less" scoped>
.top-block {
  height: v-bind(topBlockHeight);
  background-image: linear-gradient(to bottom, #ebc386, #e2b972);
  position: relative;
  .slicing {
    position: absolute;
  }
  .crescent-img {
    top: -30px;
    left: -10px;
    width: 61px;
  }
  .crown-img {
    top: 0px;
    right: 0;
    width: 219px;
  }
  .title-img {
    width: 131px;
    height: 67px;
    bottom: 60px;
    left: 16px;
  }
  .finish-time {
    font-size: 12px;
    color: #fff;
    bottom: 40px;
    left: 16px;
  }
}

.tab-bar {
  padding-top: 10px;
  :deep(.van-tab) {
    margin-right: 12px;
    &:nth-last-child(2) {
      margin-right: 0px;
    }
  }
}
.list-wrp {
  padding: 16px;
  margin-top: 8px;
  border-radius: 16px 16px 0px 0px;
  background-color: var(--van-white);
  font-size: 14px;
  .list-title {
    padding: 0 8px;
    margin-bottom: 13px;
    text-align: center;
    color: #666;
  }
  .list-box {
    padding-top: 10px;
    padding-bottom: 60px;
    .rank-list-item {
      padding: 10px 8px;
    }
  }
}
.fixed-bottom-rank {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 10px 16px;
  background: var(--van-white);
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.08);
}
</style>
